import yup from 'src/libs/yup';

export const UserStoreSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
  email: yup.string().email().required().label('E-mail'),
  password: yup.string().required().label('Senha'),
  password_confirmation: yup
    .string()
    .required()
    .equalTo(yup.ref('password'), 'senha')
    .label('Confirmação'),
});

export const UserUpdateSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
  email: yup.string().email().required().label('E-mail'),
  password: yup.string().label('Senha'),
  password_confirmation: yup
    .string()
    .equalTo(yup.ref('password'), 'senha')
    .label('Confirmação'),
});
